module.exports = __webpack_public_path__ + "static/09-518474ebf98ba404c7869c13f98fbc17.jpg";